module.exports = __webpack_public_path__ + "static/modal-1a2817c74be8f76137829bb3e753744a.png";